import React from 'react';
import PropTypes from 'prop-types';

import {
    Card,
    CardHeader,
    CardContent,
    Typography,
} from '@material-ui/core';
import { UserAvatarV2 } from './commonControls.jsx';
import { Link } from 'react-router-dom';

export default function InfoCard(props) {
    const {
        to, 
        title, titleStyle, 
        user, userStyle,
        content, contentStyle,
        className,
    } = props;
    const card = (
        <Card className={`info-card ${className}`}>
            {title !== '' && (
                <CardContent className='info-title' style={titleStyle}>
                    {title}
                </CardContent>
            )}
            {user !== null && (    
                <CardHeader 
                    className='info-user'
                    style={userStyle}
                    avatar={<UserAvatarV2 size='medium' userData={user} />}
                    title={<Typography variant='h6' style={{ fontWeight: 600 }}>{`${user.firstName} ${user.lastName}`}</Typography>} 
                    subheader={<Typography variant='body2'>{user.affiliation}</Typography>}
                />
            )}
            <CardContent className='info-content' style={contentStyle}>
                {content}
            </CardContent>
        </Card>
    );

    return to != InfoCard.defaultProps.to 
        ? <Link to={to} style={{ textDecoration: 'none' }}>{card}</Link>
        : card;
};

InfoCard.propTypes = {
    to: PropTypes.string,
    title: PropTypes.node,
    titleStyle: PropTypes.object,
    user: PropTypes.object,
    userStyle: PropTypes.object,
    content: PropTypes.node.isRequired,
    contentStyle: PropTypes.object,
};

InfoCard.defaultProps = {
    to: '',
    title: '',
    titleStyle: { color: '#000000', backgroundColor: '#FFFFFF' },
    user: null,
    userStyle: { color: '#000000', backgroundColor: '#FFFFFF' },
    contentStyle: { color: '#000000', backgroundColor: '#FFFFFF' },
};